// Home.js
import React from 'react';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, EffectFade, Pagination } from 'swiper/modules';
import { FiArrowRight, FiUsers, FiShield, FiHeart, FiLayers, FiCpu, FiLink } from 'react-icons/fi';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/pagination';
import home1 from '../assets/home1.png';
import home2 from '../assets/home2.png';
import home3 from '../assets/home3.png';
import quienes from '../assets/bvt1.jpg';

const slides = [home1, home2, home3];

const pilares = [
  { icon: FiUsers, titulo: 'Profesionalismo', desc: 'Equipo técnico calificado en múltiples disciplinas del sector industrial.' },
  { icon: FiShield, titulo: 'Compromiso', desc: 'Ejecutamos cada proyecto con responsabilidad, planificación y orientación a resultados.' },
  { icon: FiHeart, titulo: 'Confianza', desc: 'Relaciones de largo plazo con clientes públicos y privados de todo el país.' },
  { icon: FiLayers, titulo: 'Solidez', desc: 'Infraestructura propia y capacidad operativa para afrontar retos de gran escala.' },
  { icon: FiCpu, titulo: 'Innovación', desc: 'Incorporamos mejoras técnicas y soluciones adaptadas al entorno cambiante.' },
  { icon: FiLink, titulo: 'Alianzas', desc: 'Vínculos estratégicos con instituciones, gobiernos regionales y proveedores líderes.' },
];

const Home = () => {
  return (
    <div className="w-full bg-white">
      {/* Hero */}
      <section className="relative w-full h-[88vh] min-h-[560px]">
        <Swiper
          modules={[Autoplay, EffectFade, Pagination]}
          effect="fade"
          loop
          speed={1200}
          autoplay={{ delay: 5000, disableOnInteraction: false }}
          pagination={{ clickable: true }}
          className="w-full h-full"
        >
          {slides.map((img, idx) => (
            <SwiperSlide key={idx}>
              <img src={img} alt={`Slide ${idx + 1}`} className="w-full h-full object-cover" />
            </SwiperSlide>
          ))}
        </Swiper>

        <div className="absolute inset-0 bg-gradient-to-b from-primary-900/80 via-primary-900/70 to-primary-900/80 z-10"></div>

        <div className="absolute inset-0 flex flex-col items-center justify-center text-white text-center px-6 z-20">
          <p className="eyebrow !text-accent-400 mb-5 animate-fadeInUp">
            Compromiso · Confianza · Resultados
          </p>
          <h1 className="text-4xl md:text-6xl font-bold mb-5 drop-shadow-lg !text-white animate-fadeInUp" style={{ animationDelay: '0.1s' }}>
            Inversiones BVT C.A.
          </h1>
          <p className="text-lg md:text-xl max-w-2xl text-white/85 leading-relaxed animate-fadeInUp" style={{ animationDelay: '0.2s' }}>
            Soluciones integrales para el desarrollo de infraestructura, energía y servicios especializados.
          </p>
          <div className="mt-8 flex flex-wrap items-center justify-center gap-4 animate-fadeInUp" style={{ animationDelay: '0.3s' }}>
            <Link to="/servicios" className="btn-accent">
              Nuestros servicios
              <FiArrowRight className="w-4 h-4" />
            </Link>
            <Link
              to="/contacto"
              className="inline-flex items-center gap-2 rounded-full border border-white/40 px-6 py-3 text-sm font-semibold text-white transition duration-300 hover:bg-white hover:text-primary"
            >
              Contáctanos
            </Link>
          </div>
        </div>
      </section>

      {/* Sobre Nosotros */}
      <section className="py-20 bg-white">
        <div className="container-page grid md:grid-cols-2 gap-12 items-center">
          <div className="relative">
            <div className="absolute -inset-3 bg-gradient-to-tr from-primary-100 to-accent-100 rounded-2xl rotate-2"></div>
            <img src={quienes} alt="Quiénes somos" className="relative rounded-2xl shadow-card w-full h-auto object-cover" />
          </div>
          <div>
            <p className="eyebrow mb-3">Sobre nosotros</p>
            <h2 className="section-title mb-5">¿Quiénes Somos?</h2>
            <p className="text-lg leading-relaxed text-slate-600">
              Inversiones BVT, C.A, es una empresa con más de 14 años de experiencia, en el área de
              suministros, procura, dotación, consultorías, construcción de obras civiles, construcción
              de edificaciones metálicas y en concreto armado, servicio y mantenimiento de sistemas
              eléctricos de media y baja tensión, iluminación, asfaltado, alquiler de plantas de
              tratamientos de aguas y traslado de desechos petroleros, fabricación de unidades móviles
              (Tráiler). El resultado de nuestro esfuerzo se ha traducido en mejoras en la productividad
              de nuestros clientes.
            </p>
            <Link to="/nosotros" className="btn-primary mt-7">
              Conócenos más
              <FiArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </section>

      {/* Pilares */}
      <section className="py-20 bg-slate-50">
        <div className="container-page">
          <div className="text-center mb-14">
            <p className="eyebrow mb-3">Lo que nos distingue</p>
            <h2 className="section-title">Nuestros Pilares</h2>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {pilares.map((p) => (
              <div
                key={p.titulo}
                className="group rounded-2xl bg-white p-8 shadow-card transition duration-300 hover:-translate-y-1 hover:shadow-soft"
              >
                <div className="w-14 h-14 rounded-xl bg-primary-50 text-primary flex items-center justify-center mb-5 transition group-hover:bg-primary group-hover:text-white">
                  <p.icon className="w-7 h-7" />
                </div>
                <h3 className="text-xl font-semibold mb-2">{p.titulo}</h3>
                <p className="text-sm leading-relaxed text-slate-600">{p.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
